import { StandardEvents } from '@shopify/events';

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  event.promise?.then(({ cart, detail }) => {
    const count = cart?.totalQuantity ?? detail?.itemCount;
    if (!Number.isFinite(count)) return;
    document.querySelectorAll('[data-top-cart-link]').forEach((link) => {
      link.setAttribute('aria-label', `Bag, ${count} items`);
      const badge = link.querySelector('.top-cart-count');
      if (badge) {
        badge.textContent = String(count);
        badge.hidden = count === 0;
      }
    });
  }).catch(() => { /* Keep the last confirmed count when a cart request fails. */ });
});
